import { render, staticRenderFns } from "./IconUsers.vue?vue&type=template&id=1ed32f96&"
import script from "./IconUsers.vue?vue&type=script&lang=ts&"
export * from "./IconUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports